import Table from 'react-bootstrap/Table';
import './ResponsiveTable.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSortUp, faSortDown, faSort } from '@fortawesome/free-solid-svg-icons';

const ResponsiveTable = ({ headers = [], 
							data = [],
							ambitoFilter= [],
							colturaFilter= [],
							sensoreFilter= [],
							servizioFilter= [],
							grandezzaFilter= [],
							onSort,
							sortConfig }) => {
	
	const headerCellStyle = {
		backgroundColor: '#E1EBDA',
		color: '#233D62',
		position: 'sticky',
		top: '0',
		tableLayout: 'fixed'
	};
	
	const sortIconStyle = {
		marginLeft: '4px',
		cursor: 'pointer'
	};
	
	const getSortIcon = (key) => {
		if (sortConfig.key === key) {
			return sortConfig.direction === 'ascending' ? faSortUp : faSortDown;
		}
			return faSort;
	};
  
	const getFilteredData = () => {
		if (grandezzaFilter.length===0){
			return data.filter(item => {
				return ambitoFilter.some(ambitoFilter => ambitoFilter.label === item.Ambito) &&
						colturaFilter.some(colturaFilter => colturaFilter.label === item.coltura) &&
						sensoreFilter.some(sensoreFilter => sensoreFilter.label === item.Sensore) &&
						servizioFilter.some(servizioFilter => servizioFilter.label === item.Servizio);
			});
		}
		return data.filter(item => {
				return ambitoFilter.some(ambitoFilter => ambitoFilter.label === item.Ambito) &&
						colturaFilter.some(colturaFilter => colturaFilter.label === item.coltura) &&
						grandezzaFilter.some(grandezzaFilter => grandezzaFilter.label === item['Grandezza Fisico/Chimica']) &&
						sensoreFilter.some(sensoreFilter => sensoreFilter.label === item.Sensore) &&
						servizioFilter.some(servizioFilter => servizioFilter.label === item.Servizio);
			});
		
	};

	const getActiveHeaders = () => {
		const filteredData = getFilteredData();
		return headers.filter(header => {
			return filteredData.some(item => item[header] !== '');
		});
	};
	
	const activeHeaders = getActiveHeaders();

    return (
        <Table responsive bordered hover>
            <thead>
                <tr>
                    <th style={headerCellStyle}>#</th>
                    {activeHeaders.map((header, index) => (
                        <th key={index} style={headerCellStyle}>{header}
                        <FontAwesomeIcon
                            icon={getSortIcon(header)}
                            onClick={() => onSort(header)}
                            style={sortIconStyle}
                        />
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {getFilteredData().map((item, rowIndex) => (
                    <tr key={rowIndex}>
                        <td style={{ color:'#233D62'}}> {rowIndex + 1} </td>
                        {activeHeaders.map((header, colIndex) => (
                          <td style={{ color:'#233D62'}} key={`${rowIndex}-${colIndex}`}>{item[header].toString()}</td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </Table>
    );
};

export default ResponsiveTable;